import React, { Fragment, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { navtoggle } from "../../../store/actions/AuthActions";

/// React router dom
import { Link, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

import logoTextWhite from "../../../images/logo-text-white.png";
import logoText from "../../../images/logo.png";
import logoWhite from "../../../images/logo-white.png";

// ✅ AUTH UTILS
import { getRole, getHomeRouteByRole } from "../../../utils/auth";

const NavHader = () => {
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  const navigate = useNavigate();

  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);

  // ✅ GET CURRENT USER ROLE
  const role = getRole();
  const homeRoute = getHomeRouteByRole(role);

  const handleToogle = () => {
    dispatch(navtoggle());
  };

  // ✅ LOGO CLICK FIX
  const handleLogoClick = (e) => {
    e.preventDefault();

    navigate(homeRoute, { replace: true });

    // Optional: force clean refresh so sidebar/menu/header sync perfectly
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <div className="nav-header">
      <Link to={homeRoute} className="brand-logo" onClick={handleLogoClick}>
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <img className="logo-abbr" src={logoWhite} alt="logo" />
            <img className="logo-compact" src={logoTextWhite} alt="logo" />
            <img className="brand-title" src={logoTextWhite} alt="logo" />
          </Fragment>
        ) : (
          <Fragment>
            <img className="logo-compact" src={logoText} alt="logo" />
            <img className="brand-title" src={logoText} alt="logo" />
          </Fragment>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          handleToogle();
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;